import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ResourcesService} from '../../../course/services/resources.service';
import * as _ from 'underscore';
import {UserDocumentService} from '../../../course/services/user-document.service';

@Injectable({providedIn: 'root'})
export class UserDocumentResolver  {
  constructor(private userDocumentService: UserDocumentService) {
    console.log('UserDocumentResolver.constructor');
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Promise<any> {
    console.log('UserDocumentResolver.resolve');
    let userDocumentId = null;

    if (route.paramMap.get('userDocumentId')) {
      userDocumentId = route.paramMap.get('userDocumentId');
    } else if (route.queryParamMap.get('userDocumentId')) {
      userDocumentId = route.queryParamMap.get('userDocumentId');
    }

    const promise = new Promise((resolve, reject) => {
      this.userDocumentService.loadById(userDocumentId).then(value => {
        resolve(value);
      });
    });

    return promise;
  }
}
